<template lang="html">
    <section class="upcoming-order-windows">
        <div v-for="item in listOrderWindowUpcoming" :key="item.id" class="upcoming-order-windows-list">
            <h4 class="titleOrderWindow">
                <router-link :to="{ name: 'summaryOrderWindow', params: { id: item.id } }">{{ item.name }}</router-link>
            </h4>
            <p class="dateOrderWindow">{{ formatDate(item.startDate) }} >>>> {{ formatDate(item.endDate) }}</p>
        </div>
    </section>
</template>

<script lang="js">

  export default  {
    name: 'upcoming-order-windows',
    props: ["listOrderWindowUpcoming"],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.upcoming-order-windows {
    @extend %second-text;
    &-list {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
        .titleOrderWindow {
            font-family: "oswald-regular", sans-serif;
            margin: 0;
            a {
                color: $color4;
                text-decoration: none;
            }
        }
        .dateOrderWindow {
            font-family: "oswald-regular", sans-serif;
            margin: 5px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// upcomingOrderWindows.vue?71ec375b